export {
  THUMBNAIL_DIMENSIONS,
  LARGE_THUMBNAIL_DIMENSIONS,
  HD_THUMBNAIL_DIMENSIONS,
} from "@shared/constants/fileDimensions";

export const DOCUMENT_FOLDERS = "documentFolders";
export const SHARED_DRIVE = "sharedDrive";
export const MACHINE_DOCUMENTATION_DETACHED = "machineDocumentationDetached";
export const DEFAULT_PART_IMAGE_SRC = "/images/default/parts-thumbnail.svg";
export const DEFAULT_COLOR = "#0517F8";
export const BREADCRUMB_DEFAULT_TEXT_LIMIT = 30;
export const DROP_ANIMATION_ACTIVE_OPACITY = "0.5";

// Work order status
export const STATUS_BACKGROUND_COLOR_ALPHA = 0.1;
export const KANBAN_COLUMN_TITLE_BACKGROUND_COLOR_ALPHA = 0.3;
export const KANBAN_COLUMN_BACKGROUND_COLOR_ALPHA = 0.2;
export const KANBAN_COLUMN_STATUS_BACKGROUND_COLOR_ALPHA = 0.5;
export const CUSTOM_STATUS_MAX_CHARACTERS = 16;

// Custom Fields
export const CUSTOM_FIELD_MAX_NAME_LENGTH = 25;
export const CUSTOM_FIELD_SELECT_OPTION_LENGTH = 30;
export const CUSTOM_FIELD_MAX_NUMBER_LENGTH = 15;
export const CUSTOM_FIELD_MAX_TEXT_CONTENT_LENGTH = 1000;
export const CUSTOM_FIELD_MAX_DESCRIPTION_LENGTH = 2000;

// table view
export const TABLE_VIEW_COLUMN_MIN_WIDTH = 60;
export const TABLE_VIEW_COLUMN_SIZE_SUFFIX = "_TABLE_COLUMN_SIZES";
export const TABLE_VIEW_ROW_HEIGHT = 48;

// machine list
export const MACHINE_LIST_VIEW_ROW_HEIGHT = 111;
export const MACHINE_TEMPLATE_LIST_VIEW_ROW_HEIGHT = 68;
export const ITEMS_PER_PAGE = 50;
export const ITEMS_BEFORE_PAGE = 2;

export const IMAGE_SIZE_LIMIT = 10485760;
export const MAX_TEXT_INPUT_LENGTH = 75;
export const MAX_SKILL_NAME_INPUT_LENGTH = 18;
export const PROCEDURE_NAME_MAX_INPUT_LENGTH = 150;
export const MAX_TEXT_DISPLAY_LENGTH = 75;
export const FINANCE_CUSTOMER_NOTES_MAX_LENGTH = 120;
export const FINANCE_DOCUMENT_FOOTER_MAX_LENGTH = 160;
export const FINANCE_PERCENT_MAX = 100;
export const FINANCE_TAX_NAME_MAX_LENGTH = 75;
export const FINANCE_SENDER_COMPANY_NAME_MAX_LENGTH = 75;
export const FINANCE_SENDER_STREET_ADDRESS_MAX_LENGTH = 120;
export const FINANCE_SENDER_CITY_MAX_LENGTH = 75;
export const FINANCE_SENDER_POSTAL_CODE_MAX_LENGTH = 20;
export const FINANCE_VAT_ID_MAX_LENGTH = 32;
export const FINANCE_TAX_NUMBER_MAX_LENGTH = 32;
export const FINANCE_IBAN_MAX_LENGTH = 34;
export const FINANCE_BIC_SWIFT_MAX_LENGTH = 11;
export const FINANCE_BANK_NAME_MAX_LENGTH = 75;
export const FINANCE_ACCOUNT_HOLDER_NAME_MAX_LENGTH = 75;
export const FINANCE_ACCOUNT_NUMBER_MAX_LENGTH = 34;
export const FINANCE_ROUTING_NUMBER_MAX_LENGTH = 20;

export const SUPPORT_EMAIL = "support@makula.io";
export const MD_MAX_WIDTH = 1024;

export const TEAM_NAME_LENGTH = 18;

// Custom roles
export const ROLE_NAME_MAX_LENGTH = 250;
export const PIXELS_PER_MM = 3.7795275591;
export const A4_WIDTH_IN_MM = 210;

export const TIME_FORMAT_24H = "HH:mm";

export const MAX_MULTIPART_REQUESTS = 10;

export const ASSIGNEES_AVATARS_MAX_LENGTH = 3;

export const DATE_TIME_FORMAT = "YYYY-MM-DD hh:mm";
export const SEARCH_RESULT_TABLE_VIEW_COLUMN_MIN_WIDTH = 120;

export const CSV_RESOURCES = {
  INVENTORY_PART: "InventoryPart",
  CUSTOMER: "Customer",
  TICKET: "Ticket",
  MACHINE: "Machine",
  MACHINE_HISTORY: "MachineHistory",
  MACHINE_TEMPLATE: "MachineTemplate",
};

export const CSV_DOWNLOADING_TOAST_ID = "csv-downloading-toast";
export const SLATE_EMPTY_TEXT =
  '[{"type":"paragraph","children":[{"text":""}]}]';

export const SENDING_EMAIL_TOAST_ID = "sending-email-toast";
export const VALIDATING_ASSISTANT_FILES_TOAST_ID =
  "validating-assistant-files-toast";
export const SAVING_GUIDE_TOAST_ID = "saving-guide-toast";
export const API_RESPONSE_OK = "ok";

export const SORTING_ORDER = {
  ASCENDING: "asc",
  DESCENDING: "des",
};

export const INVENTORY_SORTING_KEY = {
  NAME: "name",
  ARTICLE_NUMBER: "articleNumber",
  DESCRIPTION: "description",
};

export const FINANCE_QUOTES_SORTING_KEY = {
  QUOTE_NUMBER: "quoteNumber",
  COMPANY: "company",
  STATUS: "status",
  TOTAL_AMOUNT: "totalAmount",
  CREATED_BY: "createdBy",
  CREATED_AT: "created_at",
  VALID_UNTIL: "validUntilDate",
  ISSUE_DATE: "issueDate",
};

export const FINANCE_INVOICES_SORTING_KEY = {
  INVOICE_NUMBER: "invoiceNumber",
  COMPANY: "company",
  STATUS: "status",
  TOTAL_AMOUNT: "totalAmount",
  CREATED_BY: "createdBy",
  CREATED_AT: "created_at",
  DUE_DATE: "dueDate",
  ISSUE_DATE: "issueDate",
};

export const DOCUMENTS_TABS = {
  EXTERNAL: "external",
  INTERNAL: "internal",
};

export const DEBOUNCE_TIMEOUT = 100;

export const SIGNUP_SOURCE = {
  AI_NOTETAKER: "AI Notetaker",
  GROWTH_LOOP: "Growth Loop",
  SALES_MOTION: "Sales Motion",
  PRODUCT_CATALOG: "Product Catalog",
};
